import React, { useCallback } from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { SecondaryButton } from '../../../design/components';
import SetupPickerField from '../components/SetupPickerField';
import SetupTextField from '../components/SetupTextField';
import {
	MARKET_SETUP_BAY_VALUE,
	MARKET_SETUP_BAY_VALUE_NAME,
} from '../../../../common/constants';
import { toNumber } from './MarketSetupDetailHelpers';
import { createMarketSetupDetailStyles } from './MarketSetupDetail.styles';

const MarketSetupBays = ({ marketSetup, updateMarketSetup }) => {
	const styles = useThemedStyles(createMarketSetupDetailStyles);
	const handleMarketBayChange = useCallback((index, key, value) => {
		const bays = marketSetup.marketBays?.length ? [...marketSetup.marketBays] : [{ value: null, custom: null }];
		const nextBay = {
			...(bays[index] || {}),
			[key]: key === 'value' ? toNumber(value) : value,
		};

		if (key === 'value' && nextBay.value !== MARKET_SETUP_BAY_VALUE.CUSTOM_SHELVING) {
			nextBay.custom = null;
		}

		bays[index] = nextBay;
		updateMarketSetup({ marketBays: bays });
	}, [marketSetup.marketBays, updateMarketSetup]);

	const handleRemoveMarketBay = useCallback((index) => {
		const bays = (marketSetup.marketBays || []).filter((_, i) => i !== index);
		updateMarketSetup({ marketBays: bays.length ? bays : [{ value: null, custom: null }] });
	}, [marketSetup.marketBays, updateMarketSetup]);

	const addMarketBay = useCallback(() => {
		const bays = marketSetup.marketBays?.length ? [...marketSetup.marketBays] : [];
		bays.push({ value: null, custom: null });
		updateMarketSetup({ marketBays: bays });
	}, [marketSetup.marketBays, updateMarketSetup]);

	return (
		<>
			{
				(marketSetup.marketBays || [{ value: null, custom: null }]).map((bay, index) => (
					<View key={`bay_${index}`} style={styles.bayCard}>
						<SetupPickerField
							label={`Market bay ${index + 1}`}
							value={bay?.value}
							onChange={value => handleMarketBayChange(index, 'value', value)}
							options={Object.values(MARKET_SETUP_BAY_VALUE).map(value => ({
								label: MARKET_SETUP_BAY_VALUE_NAME[value],
								value,
							}))}
							required={true}
						/>
						{
							bay?.value === MARKET_SETUP_BAY_VALUE.CUSTOM_SHELVING && (
								<SetupTextField
									label={`Bay ${index + 1} custom`}
									value={bay?.custom}
									field="custom"
									onConfirm={({ custom }) => handleMarketBayChange(index, 'custom', custom)}
									hint="Enter the width in mm of the custom shelving."
									required={true}
								/>
							)
						}
						{
							(marketSetup.marketBays || []).length > 1 && (
								<View style={styles.inlineAction}>
									<SecondaryButton label="Remove" icon="trash-2" onPress={() => handleRemoveMarketBay(index)} />
								</View>
							)
						}
					</View>
				))
			}
			<View style={styles.addAction}>
				<SecondaryButton label="Add bay" icon="plus" onPress={addMarketBay} />
			</View>
		</>
	);
};

export default MarketSetupBays;
